import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "commentsContainer" }
const _hoisted_2 = { class: "scrollListContainer" }
const _hoisted_3 = {
  key: 0,
  class: "scrollListItem"
}
const _hoisted_4 = { class: "top" }
const _hoisted_5 = { class: "date" }
const _hoisted_6 = { class: "author" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "bottom" }
const _hoisted_9 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_comment_form = _resolveComponent("new-comment-form")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_comment_text = _resolveComponent("comment-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.modify)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.readonly)
            ? (_openBlock(), _createBlock(_component_new_comment_form, {
                key: 0,
                modelValue: _ctx.vm,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vm) = $event)),
                onAdd: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('add', $event)))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.comments.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_localized_text, {
              localizedKey: "Nessun elemento inserito",
              text: "Nessun elemento inserito"
            })
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.comments, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "scrollListItem comment",
              key: i
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$filters.date(item.createdOn, 'DD-MM-YYYY HH:mm')), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(item.author.name), 1),
                (_ctx.$store.state.isAdmin())
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "deleteComment",
                      onClick: ($event: any) => (_ctx.deleteComment(item))
                    }, _cache[2] || (_cache[2] = [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-mini btn-danger"
                      }, "x", -1)
                    ]), 8, _hoisted_7))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_comment_text, { comment: item }, null, 8, ["comment"]),
                (item.attachments.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.attachments, (x, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "fs-12"
                      }, [
                        _createElementVNode("a", {
                          class: "text-orange",
                          href: x.publicUrl,
                          target: "_blank"
                        }, _toDisplayString(x.filename), 9, _hoisted_9)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
    ])
  ]))
}